'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBrightnessAuto = function DeviceBrightnessAuto(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z' })
  );
};
DeviceBrightnessAuto = (0, _pure2.default)(DeviceBrightnessAuto);
DeviceBrightnessAuto.displayName = 'DeviceBrightnessAuto';
DeviceBrightnessAuto.muiName = 'SvgIcon';

exports.default = DeviceBrightnessAuto;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/device/brightness-auto.js
// module id = 2157
// module chunks = 0